import {CLOSE_BET_HISTORY, OPEN_BET_HISTORY, TOGGLE_FILTER_WINS_BET_HISTORY} from '../constants/actionTypes';
import {DISABLED_VIRTUALS, VIRTUALS} from "../../../constants/games";
import defaultStoreValues from '../../../constants/defaultStoreValues';

export default (state, action) => {
    switch (action.type) {
        case OPEN_BET_HISTORY:

            return {
                ...state,
                isBetHistoryOpen: true,
                betHistory: action.betHistory.filter((sBets) => VIRTUALS.find(game => game.channel === sBets.Bets[0].Channel) || DISABLED_VIRTUALS.find(dGame => dGame.channel === sBets.Bets[0].Channel)),
                filterWinsBetHistory: defaultStoreValues.filterWinsBetHistory
            };
        case CLOSE_BET_HISTORY:
            return {
                ...state,
                isBetHistoryOpen: defaultStoreValues.isBetHistoryOpen,
                betHistory: defaultStoreValues.betHistory,
                filterWinsBetHistory: defaultStoreValues.filterWinsBetHistory
            };
        case TOGGLE_FILTER_WINS_BET_HISTORY:
            return {
                ...state,
                filterWinsBetHistory: !state.filterWinsBetHistory
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/reducers/betHistoryReducer.js